import { FC, InputHTMLAttributes } from "react";
import { cn } from "../../utility/cn";
import { FormError } from "./form";

interface InputControlProps {
    touched?: boolean;
    error?: string;
    label?: string;
    required?: boolean;
    className?: string; // For the grid column wrapper (e.g., "col-lg-8")
    labelWidth?: string; // e.g., "col-lg-4"
    helpText?: string;
}

interface InputProps extends InputHTMLAttributes<HTMLInputElement>, InputControlProps { }


/**
 * Input Component
 * Automatically handles the 'is-invalid' class and rendering the error message
 */
export const Input: FC<InputProps> = ({
    touched,
    error,
    className,
    type = 'text',
    ...props
}) => {
    const isInvalid = touched && error;

    return (
        <>
            <input
                type={type}
                className={cn(
                    'form-control form-control-lg form-control-solid',
                    isInvalid && 'is-invalid',
                    className
                )}
                {...props}
            />
            <FormError error={isInvalid ? error : undefined} />
        </>
    );
};